import { useEffect, useState } from "react";
import { Menu, Phone, X } from "lucide-react";

const links = [
  { label: "Interior", href: "#interiors", testId: "header-interior-link" },
  { label: "Food Gallery", href: "#food-gallery", testId: "header-food-gallery-link" },
  { label: "Make a Booking", href: "#celebrations", testId: "header-booking-link" },
  { label: "Contact Us", href: "#visit", testId: "header-contact-link" },
];

export default function Header({ phoneTel }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 18);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setIsOpen(false);

  return (
    <header className={`site-header ${isScrolled ? "is-scrolled" : ""}`} data-testid="site-header">
      <div className="header-inner">
        <a href="#top" className="header-brand" data-testid="header-brand-link" onClick={closeMenu}>
          <img src="/assets/hashtag-logo-cropped.png" alt="Hashtag MultiCuisine Restaurant & Garden" />
        </a>
        <nav className="header-nav" aria-label="Main navigation">
          {links.map((link) => <a key={link.href} href={link.href} data-testid={link.testId}>{link.label}</a>)}
        </nav>
        <a href={phoneTel} className="header-call" data-testid="header-call-link">
          <Phone aria-hidden="true" />
          <span>Call now</span>
        </a>
        <button
          type="button"
          className="header-menu-toggle"
          aria-label={isOpen ? "Close menu" : "Open menu"}
          aria-expanded={isOpen}
          data-testid="header-mobile-menu-button"
          onClick={() => setIsOpen((open) => !open)}
        >
          {isOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
      </div>
      {isOpen && (
        <nav className="header-mobile-nav" aria-label="Mobile navigation" data-testid="header-mobile-nav">
          {links.map((link) => <a key={link.href} href={link.href} data-testid={`mobile-${link.testId}`} onClick={closeMenu}>{link.label}</a>)}
          <a href={phoneTel} data-testid="mobile-call-link" onClick={closeMenu}>Call the restaurant</a>
        </nav>
      )}
    </header>
  );
}
